import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { AppState } from 'src/store';
import * as api from 'src/api/invoice';

export const getNoInvoiceList = createAsyncThunk(
    `invoiceSlice/getNoInvoiceList `,
    async (_, { getState, rejectWithValue }) => {
        try {
            const { beginDate, endDate, distributorName, page, productName, take } = (getState() as AppState).invoice
                .pagination;
            const res = await api.getNoInvoice(page, take, beginDate, endDate, distributorName, productName);
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

const invoiceSlice = createSlice({
    name: `invoiceSlice`,
    initialState,
    reducers: {
        initInvoiceSlice: () => {
            return initialState;
        },
        initSearch: state => {
            state.pagination.beginDate = initialState.pagination.beginDate;
            state.pagination.endDate = initialState.pagination.endDate;
            state.pagination.distributorName = initialState.pagination.distributorName;
            state.pagination.productName = initialState.pagination.productName;
        },
        updateTake: (state, action: PayloadAction<number>) => {
            state.pagination.take = action.payload;
        },
        updatePage: (state, action: PayloadAction<number>) => {
            state.pagination.page = action.payload;
        },
        updateBeginDate: (state, action: PayloadAction<string>) => {
            state.pagination.beginDate = action.payload;
        },
        updateEndDate: (state, action: PayloadAction<string>) => {
            state.pagination.endDate = action.payload;
        },
        updateDistributorName: (state, action: PayloadAction<string>) => {
            state.pagination.distributorName = action.payload;
        },
        updateProductName: (state, action: PayloadAction<string>) => {
            state.pagination.productName = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getNoInvoiceList.fulfilled, (state, { payload }) => {
            state.emptyInvoicePage = payload;
        });
    },
});

export default invoiceSlice.reducer;
export const {
    initInvoiceSlice,
    initSearch,
    updateBeginDate,
    updateDistributorName,
    updateEndDate,
    updatePage,
    updateTake,
    updateProductName,
} = invoiceSlice.actions;
